import { PROD } from '../config/stage'

const environmentPrefix = import.meta.env.VITE_STAGE === PROD ? '' : `shared-`

const remoteUrl = import.meta.env.VITE_REMOTE_URL

const apiBaseUrl =
  remoteUrl && remoteUrl.trim().length > 0 ? remoteUrl : `https://api.${environmentPrefix}platform.eidu.com/`

export default apiBaseUrl
